// extracted by mini-css-extract-plugin
export default {"logoSection":"Terms_logoSection__kAu6d","logo":"Terms_logo__WwkXi","brandTitle":"Terms_brandTitle__A1z4B"};